import { FocusIcon as e } from "lucide-react";
import { jsx as t } from "react/jsx-runtime";
// lib/components/CropDialog/VisualFocus.tsx
var n = ({ focus: n }) => /* @__PURE__ */ t(e, {
	color: "rgba(255, 255, 255, 0.9)",
	className: "absolute w-[40px] h-[40px] -mt-[20px] -ml-[20px] rounded-[12px] flex items-center justify-center pointer-events-none",
	style: {
		left: `${n.x * 100}%`,
		top: `${n.y * 100}%`
	}
});
export { n as VisualFocus };
